<template>
  <div class="rmaForm">
    <label for="faultDescription">{{
      $mlGet("rmaReason-faultDescription-label")
    }}</label
    ><br />
    <textarea
      name="faultDescription"
      id="faultDescription"
      v-model="$store.state.rma.faultDescription"
    ></textarea>
    <form v-on:submit.prevent="" style="text-align: left">
      <div class="uploadWrapper">
        <label for="uploadField">{{ $mlGet("rmaReason-upload-label") }}</label>
        <label class="uploadLabel" for="uploadField">{{
          $mlGet("rmaReason-upload-button")
        }}</label>
        <input
          type="file"
          ref="uploadField"
          id="uploadField"
          @change="uploadHandler"
          class="uploadButton"
        />
        <div id="uploadedBox" v-if="$store.state.rma.files">
          <table id="uploadResultsTable">
            <tr
              v-for="(file, index) in $store.state.rma.files"
              :key="file.filename"
            >
              <td>
                <i class="fa fa-file" aria-hidden="true" />
                {{ file.originalname }}
              </td>
              <td @click="removeHandler(file)">
                <i class="fa fa-minus fileRemove" aria-hidden="true"></i>
              </td>
              <td>{{ index + 1 }} of 6</td>
            </tr>
          </table>
        </div>
      </div>
    </form>
    <div class="information-box">
      <span v-html="$mlGet('rmaReason-informationBox')"></span>
    </div>
  </div>
</template>

<script lang="ts">
import { highlightElementQuerySelector } from "@/helpers/alerts";
import { FormFile } from "@/types";
import { PageChangeContext, PageName } from "@/views/CreateRma.vue";
import { AxiosError } from "axios";
import { Component, Vue } from "vue-property-decorator";
import * as Sentry from "@sentry/vue";

@Component
export default class RmaReason extends Vue {
  $refs!: {
    uploadField: HTMLFormElement;
  };

  removeHandler(file: FormFile): void {
    const index = this.$store.state.rma.files.indexOf(file);
    if (index >= 0) this.$store.state.rma.files.splice(index, 1);
  }

  uploadHandler(): void {
    if (this.$store.state.rma.files.length > 6) return;
    const file = this.$refs.uploadField.files[0];
    const formData = new FormData();
    formData.append("photo", file);

    this.$axios
      .post("/rma/file", formData, {
        headers: {
          "Content-Type": "multipart-formdata"
        }
      })
      .then(response => {
        const file: FormFile = (({
          originalname,
          filename,
          mimetype,
          size
        }) => ({ originalname, filename, mimetype, size }))(response.data.file);
        this.$store.state.rma.files.push(file);
        this.$forceUpdate();

        Sentry.metrics.count("description_file_upload", 1);

        this.$swal({
          icon: "success",
          title: this.$mlGet("fileUpload-success-head"),
          showConfirmButton: false,
          timer: 1500
        });
      })
      .catch(error => {
        if (error instanceof AxiosError) {
          this.$swal(
            this.$mlGet("fileUpload-error-head"),
            error?.response?.data?.error ?? "Upload Error",
            "error"
          );
        }
      });
  }

  public async beforePageLeave(context: PageChangeContext): Promise<boolean> {
    if (context.isReturnOperation) return true;

    if (this.$store.state.rma.faultDescription == "") {
      highlightElementQuerySelector("#faultDescription");
      return false;
    }

    if (this.$store.state.rma.faultDescription.length < 10) {
      await this.$swal(
        "",
        this.$mlGet("error-faultDescription-min"),
        "warning"
      );
    }

    return true;
  }

  public async afterPageEnter(context: PageChangeContext): Promise<void> {
    return;
  }

  public async onPageLeave(context: PageChangeContext): Promise<PageName> {
    return "TransportSelection";
  }
}
</script>

<style scoped>
* {
  text-align: left;
}

textarea {
  width: 100%;
  height: 20vh;
  font-family: sans-serif;
  resize: none;
}

label {
  margin: 0 20px 0 0;
}

.uploadWrapper {
  margin: 10px 0;
}

.uploadButton {
  visibility: hidden;
}

.uploadLabel {
  background-color: #da6f38 !important;
  padding: 4px 8px;
  color: white;
  border-radius: 5px;
  font-weight: bold;
  margin: 10px;
  cursor: pointer;
}

#uploadedBox {
  margin: 7px 0;
}

.fileRemove {
  color: #c93030;
  font-size: 150%;
  margin: 0 0 -5px 0;
  cursor: pointer;
}

#uploadResultsTable {
  table-layout: fixed;
  width: 95%;
}
</style>
